import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./service.css";
import { Link } from "react-router-dom"; // Import Link from react-router-dom

const expertiseList = [
  { title: "MARKETING", image: "/images/service1.png", path: "/s" },
  { title: "BRANDING", image: "/images/service2.png", path: "/branding" },
  { title: "TECHNOLOGY", image: "/images/service3.png", path: "/technology" },
  { title: "MEDIA PODUCTION", image: "/images/services4.png", path: "/media-production" },
  { title: "PR MANAGEMENT", image: "/images/service5.png", path: "/pr-management" },
  { title: "DIGITAL STRATERGY", image: "/images/service6.png", path: "/digital-stratergy" },
];

function Services() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });
  }, []);

  return (
    <section className="expertise-container">
      <h2 className="expertise-header">
        Explore Our <span className="expertise-highlight">Expertise</span>
      </h2>
      <div className="expertise-card-group">
        {expertiseList.map((item, idx) => (
          <div
            className="expertise-card"
            key={idx}
            data-aos="flip-left"
            data-aos-delay={idx * 150}
          >
            <img src={item.image} alt={item.title} className="expertise-img" />
            <div className="expertise-detail">
              <h3 className="expertise-title">{item.title}</h3>
              <Link to={item.path} className="expertise-button">
                {/* Use Link component with 'to' prop */}
                Know More
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Services;